module Omni.ResortMap {
    ngModule.directive('youtube', ['$sce',
        function ($sce) {
            return {
                restrict: 'E',
                template: '<iframe width="692" height="390" src="{{ video_url }}" frameborder="0" allowfullscreen></iframe>',
                replace: true,
                link: function (scope, element, attrs) {
                    scope.video_url = $sce.trustAsResourceUrl(scope.location.video_url);
                }
            };
        }]);
}
